// -----------------------------------------------------------------------------

import { GenericObject } from "utility/misc";

const COLORS = ["#FF6257", "#FF9357", "#FFBC57", "#3C9D40"];
const TOTAL_SCORE = 800;
const SEGMENT = TOTAL_SCORE / COLORS.length;

export default function getGaugeData(riskScore: number = 0) {
  let workingRiskScore = riskScore;

  const pieData: GaugeDataProps[] = COLORS.map((color: string) => {
    const item = {
      id: color,
      color,
      label: "",
      value: Math.max(0, Math.min(workingRiskScore, SEGMENT)),
    };

    workingRiskScore -= SEGMENT;
    return item;
  });

  // Push an empty segment if needed
  if (riskScore < TOTAL_SCORE) {
    pieData.push({
      id: "#D9D9D9",
      color: "#D9D9D9",
      label: "",
      value: TOTAL_SCORE - riskScore,
    });
  }

  // Filter out any empty segments
  const finalPieData = pieData.filter(
    (segment: GaugeDataProps) => segment.value !== 0
  );

  return (finalPieData || []) as GenericObject[];
}

interface GaugeDataProps {
  id: string;
  label: string;
  value: number;
  color?: string;
}
